import React from 'react';
import { getGenreString, formatDate, useOffer } from '../../utils/helpers';

import MediaDetails from '../MediaDetails';
import CastList from '../CastList';
import Swimlane from '../Swimlane';

import { IMedia } from '../../utils/models';
import { TAccessServiceType } from '../../@types/Access';
import { KiteIcon, KiteLink } from '@kite/react-kite';
export interface SeriesDetailsProps {
  media: IMedia;
  similarAssets: IMedia[];
  analytics: any;
}

const SeriesDetails = ({
  media: {
    title,
    imageUrl,
    description,
    descriptors,
    genres,
    ratings,
    releaseDate,
    topCast,
    offer,
    accessServices,
  },
  similarAssets,
  analytics,
}: SeriesDetailsProps) => {
  const { startTime, endTime } = useOffer(offer);
  const rating =
    ratings && ratings.find((rating) => rating.agency === 'usTv')?.rating;
  const genreString = getGenreString(genres);

  const statLine = (
    <div className="stat-line">
      {genreString && <span className="stat-line__segment">{genreString}</span>}
      {rating && (
        <span className="stat-line__segment">
          {(rating as any)?.value || rating}
        </span>
      )}
    </div>
  );

  const preDescription = (
    <div className="pre-description">
      {/* Original Airdate */}
      {releaseDate && (
        <span className="pre-description__detail">
          <span className="label">Original Airdate</span>
          {formatDate(releaseDate)}
        </span>
      )}
    </div>
  );
  return (
    <>
      <MediaDetails
        mediaType="series"
        title={title}
        imageUri={`${imageUrl}?sourceType=colorHybrid&twccategory=Poster&width=257`}
        description={description}
        statLine={genres?.length || rating ? statLine : null}
        preDescription={releaseDate ? preDescription : null}
        moods={descriptors?.moods}
        accessibleFeatures={accessServices || []}
        dates={{ startTime, endTime }}
      />
      {topCast?.length ? (
        <section>
          <h2 className="section-title">Cast</h2>
          <CastList cast={topCast} />
        </section>
      ) : null}

      {/* Related To Swimlane */}
      {similarAssets?.length ? (
        <>
          <hr className="page__divider" aria-hidden={true} />
          <Swimlane
            title={`Related To ${title}`}
            items={similarAssets}
            analyticsConfig={{
              analytics,
              eventCase:
                'SpectrumOnDemand_selectContent_related_tvShows_assetSelection',
            }}
          />
        </>
      ) : null}
    </>
  );
};

export default SeriesDetails;
